export default {
  Description: {
    SearchTitle: 'Hệ thống tuyển sinh trực tuyến',
    SearchSubtitle: 'Hỗ trợ tra cứu thông tin tuyển sinh, nộp hồ sơ trực tuyến nhanh chóng và thuận tiện',
    EnterSchoolName: 'Nhập tên trường',
    EnterPhoneNumber: 'Nhập số điện thoại',
    EnterDateOfBirth: 'Nhập ngày sinh của con',
    SchoolListTitle: 'Danh sách những trường trong khu vực',
    ApplyOnlineGuide: 'Hướng dẫn nộp hồ sơ trực tuyến',
    ApplyOnlineGuideDescription: 'Phụ huynh có thể xem hướng dẫn chi tiết về cách thức nộp hồ sơ trực tuyến cho con',
    ViewGuide: 'Xem hướng dẫn',
    SearchResult: 'Tìm thấy <b>{amount}</b> kết quả',
    RecentSearchResult: 'Kết quả tìm kiếm gần đây',
    DataRange: '({fromDate} - {toDate})',
    NumberOfStudent: 'Chỉ tiêu: {number} học sinh',
    MyProfile: 'Hồ sơ của tôi',
    NoResult: 'Không tìm thấy kết quả nào',
    PleaseCheckInput: 'Vui lòng kiểm tra lại thông tin tìm kiếm',
  },

  SearchOption: {
    School: 'Tìm trường',
    Profile: 'Tìm hồ sơ',
  },

  ProfileSearchError: {
    PhoneAndDateEmty: 'Số điện thoại và ngày sinh không được để trống',
    PhoneEmpty: 'Số điện thoại không được để trống',
    DateEmpty: 'Ngày sinh không được để trống',
    PhoneNotValidate: 'Số điện thoại không hợp lệ',
  },

  EnrollmentStatus: {
    None: 'Chưa tuyển sinh',
    OnTime: 'Đang tuyển sinh',
    NotExpired: 'Chưa nhận hồ sơ',
    Expired: 'Hết hạn tuyển sinh',
  },

  Profile: {
    SubmissionDate: 'Ngày nộp:',
    SchoolFeedback: 'Phản hồi từ nhà trường: {feedback}',
  },
}
